import { simpleSet } from '@r/reducers/utils';

const s = simpleSet as redux.reducers.sceneInitialized;
export const sceneInitialized = s( 'SET_SCENE_INITIALIZED', false );
